import './css/bootstrap.min.css';
import './css/dataTables.bootstrap4.min.css';
import './App.css';
import $ from 'jquery'
import { Component, Fragment } from 'react';
import axios from 'axios';
import 'datatables.net'
import 'datatables.net-dt/css/jquery.dataTables.css'
import { IpoHeader, IpoFooter } from './ipo-header';

$.DataTable = require('datatables.net')

export default class Ipo_Details extends Component {
  
  state = {
    data: [],
    clientCode : null,
    category : '',
    ipoQty : 1,
    discount : '0',
    bid_UPI : '',
    ipo_terms : false,
    detailsPopUp : true,
    message : '',
    is_loading : false
  }
  table;
  columns = [
    {
      name: 'Symbol',
      selector: row => row.symbol,
      data: 'symbol',
      autoWidth: true
    },{
      data: 'category',
      autoWidth: true
    },{
      data: 'applicationNumber',
      autoWidth: true
    },{
      data: 'pan',
      orderable: false,
      autoWidth: true
    },{
      data: 'clientBenId',
      orderable: false,
      autoWidth: true
    },{
      data: 'quantity',
      autoWidth: true
    },{
      data: 'upi',
      autoWidth: true
    },{
      data: 'timestamp',
      autoWidth: true
    },{
      data: {},
      orderable: false,
      className: 'center',
      autoWidth: true,
      render: (data) => {
        return (<a type="button" class="btn btn-info btn-sm" style={{whiteSpace: "nowrap"}} onclick="this.bidRemove(data)">Delete ' + data.symbol + '</a>); 
      }
    }
  ]

  constructor(props) {
    super(props)
    window.ipoLogin = JSON.parse(sessionStorage.getItem("ipoLogin"));
    
  }

  componentDidMount(){
    if(this.state.clientCode===null && window.ipoLogin.user_details.length > 0 && window.ipoLogin.user_details[0].clientCode){
      if(!this.table){
        this.table = $('#mybids').DataTable({
          paging: false,
          bInfo : false,
          data: [],
          columns:this.columns
        });
      }

      this.setState({clientCode : window.ipoLogin.user_details[0].clientCode})
      this.changeClientCode(window.ipoLogin.user_details[0].clientCode)
    }
    
  }

  async addIPOBids(){
    if(this.state.is_loading){
      return;
    }
    const {bid_UPI, category, clientCode, discount, ipoQty, ipo_terms} = this.state
    if(bid_UPI && category && clientCode && ipoQty && ipo_terms==='true'){
      this.state.is_loading = true;
      var args_body = JSON.stringify({
        "symbol": window.ipoLogin.ipo_type.symbol,
        "category": category,
        "clientCode": clientCode,
        "upi": bid_UPI,
        "quantity": ipoQty * window.ipoLogin.ipo_type.minBidQuantity,
        "price": window.ipoLogin.ipo_type.cutOffPrice ,
        "amount": (window.ipoLogin.ipo_type.cutOffPrice - Number(discount)) * Number(window.ipoLogin.ipo_type.minBidQuantity * ipoQty)
      });
      var config = {
        method: 'post',
        url: 'https://app.patelwealth.com/eng_ipo/api/v1/bid/',
        headers: { 
          'Api-Key': '8f1eacab-780e-4b7e-a375-0569da25a65f', 
          'Authorization' : 'Bearer ' + window.ipoLogin.login_details.access_token,
          'Content-Type': 'application/json'
        },
        data : args_body
      };
      await axios(config).then(res => {
          const data = res.data;
          this.state.is_loading = false;
          if(data.reason){
            delete window.ipoLogin.ipo_type
            sessionStorage.setItem("ipoLogin", JSON.stringify(window.ipoLogin));
            this.setState({message : data.reason});
          }
      });
    }
  }

  async changeClientCode(clientCode){
    if(clientCode){
      await axios.get('https://app.patelwealth.com/eng_ipo/api/v1/bid/?clientCode='+clientCode+'&status=success', {
        headers : {
          "Api-Key": "8f1eacab-780e-4b7e-a375-0569da25a65f", 
          'Authorization' : 'Bearer ' + window.ipoLogin.login_details.access_token, 
          "content-type" : "application/json"
        }
      }).then(res => {
          this.setState({data: res.data.content});
          setTimeout(() => {
            if(this.table){ 
              // $('#mybids').dataTable().fnClearTable();
              // $('#mybids').dataTable().fnDestroy();
            }
            // this.table = $('#mybids').DataTable({
            //   paging: false,
            //   bInfo : false,
            //   data: this.state.data,
            //   columns:this.columns
            // });
          },500)          
      });
    }
  }

  bidRemove = async (data) => {
    if(data && window.confirm("Are you sure you want to delete this bid?")){
      let mythis = this
      await axios.delete('https://app.patelwealth.com/eng_ipo/api/v1/bid/'+data.symbol+'/'+data.applicationNumber, {
        headers : {
          "Api-Key": "8f1eacab-780e-4b7e-a375-0569da25a65f", 
          'Authorization' : 'Bearer ' + window.ipoLogin.login_details.access_token, 
          "content-type" : "application/json"
        }
      }).then(res => {
          const data = res.data;
          if(data.reason){
            mythis.setState({message : data.reason});
            mythis.changeClientCode(mythis.state.clientCode)
          }
      });
    }
  }

  render(){
    return (
      <Fragment>
      <IpoHeader />
      <div className="page container mt-lg my-4">
        <div className="container">
          <div className="row">
            <div className="col-md-12 border border-light br-3 py-3">
              <div className='mybids-heading'><span>My Bids</span>
              <select name="select-clientCode" onChange={(e) => { this.setState({clientCode : e.target.value}); this.changeClientCode(e.target.value) }}>
                { window.ipoLogin.user_details.map((user) => {
                    return (<option key={user.clientCode.toString()} value={user.clientCode}>{user.clientCode}</option>)
                  })
                }
              </select>
              </div>
              <table id="mybids" className="table table-striped table-bordered" >
                  <thead className='table-dark'>
                      <tr>
                          <th>Symbol</th>
                          <th>Category</th>
                          <th>App No.</th>
                          <th>PAN No.</th>
                          <th>DP Id</th>
                          <th>Qty.</th>
                          <th>UPI</th>
                          <th>Time</th>
                          <th>Action</th>
                      </tr>
                  </thead>
                  <tbody>
                    { this.state.data &&
                      this.state.data.map( (item) => {
                        return (<tr key={item.applicationNumber+'-'+item.symbol}>
                          <td className='font-weight-bold'>{item.symbol}</td>
                          <td>{item.category}</td>
                          <td>{item.applicationNumber}</td>
                          <td>{item.pan}</td>
                          <td>{item.clientBenId}</td>
                          <td>{item.quantity}</td>
                          <td>{item.upi}</td>
                          <td>{item.timestamp}</td>
                          <td><button className={'btn btn-info btn-sm ml-2'} onClick={() => this.bidRemove(item)} style={{whiteSpace: 'nowrap'}}><svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 448 512" fill="#fff"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg></button></td>
                      </tr>)
                      })
                    }
                  </tbody>
              </table> 
              {/* <DataTable
                  title="Test"
                  columns={this.columns}
                  data={this.state.data}
                  pagination
              /> */}
            </div>
          </div>
        </div>
        
        { window.ipoLogin && window.ipoLogin.user_details && window.ipoLogin.ipo_type && this.state.detailsPopUp &&
          <div className="modal d-block" id="ipo-bid-form">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header text-center">
                 <h6 className="modal-title w-100 font-weight-bold">Apply For {window.ipoLogin.ipo_type.symbol}</h6>
                  <button type="button" className="close" onClick={() => {
                    this.setState({apply_now : false, ipo_apply : false, error_msg : '', message: '',detailsPopUp : false});
                    delete window.ipoLogin.ipo_type;
                    sessionStorage.setItem("ipoLogin", JSON.stringify(window.ipoLogin)); }}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body mx-3">
                    <div className="md-form mb-3">

                    { window.ipoLogin && window.ipoLogin.user_details &&
                      <Fragment>
                        <div className='ipo-select'>
                          <label>Client Code : </label>
                          <select name="select-clientCode" onChange={(e) => this.setState({clientCode : e.target.value})}>
                            <option value=''>Select Code</option> 
                            { window.ipoLogin.user_details.map((user) => {
                              return (<option key={user.clientCode.toString()} value={user.clientCode}>{user.clientCode}</option>)
                            })
                            }
                          </select>
                        </div>
                        { window.ipoLogin.ipo_type && window.ipoLogin.ipo_type.category && 
                        <div className='ipo-select'>
                          <label>Category : </label>
                          <select name="select-clientCode" onChange={(e) => {
                              window.ipoLogin.ipo_type.category.map((cat) => {
                                if(e.target.value == cat.code){
                                  this.setState({category : cat.code, discount: cat.discount })
                                }
                              });
                            }
                          } value={this.state.category}>
                            <option value=''>Select Category</option>
                            { window.ipoLogin.ipo_type.category.map((cat) => {
                                return (<option key={cat.code.toString()} value={cat.code}>{cat.code}</option>)
                              })
                            }
                          </select>
                        </div>
                        }
                      </Fragment>
                    }
                      <div className='d-block flex-wrap mt-3 position-relative small'>
                        {this.state.clientCode &&
                          <Fragment>
                            { window.ipoLogin.user_details.map(obj => { 
                              return (<Fragment>{obj.clientCode === this.state.clientCode && <Fragment><div className='d-block my-1'><span><b>Pan Number : </b><span>{obj.panNo}</span></span></div><div className='d-block my-1'><span><b>DP Id : </b><span>{obj.memberDpId }</span></span></div><div className='d-block my-1'><span><b>Client Id : </b><span>{obj.dpId }</span></span></div></Fragment>}</Fragment>)
                            })
                            }
                            </Fragment>
                        }

                        <div className='d-block my-1'><span><b>Offer Price : </b></span><span>{window.ipoLogin.ipo_type.cutOffPrice}</span></div>

                        <div className='d-block my-1'><span><b>Discount : </b></span><span>{this.state.discount}</span></div>

                        <div className='d-block my-1'><span><b>Bid Qty : </b></span><span>{window.ipoLogin.ipo_type.lotSize * this.state.ipoQty}</span></div>

                        <div className='align-items-center my-1 d-flex'><span><b>Bid Value : </b></span><span className='ipo-bid-val'>{(window.ipoLogin.ipo_type.cutOffPrice - Number(this.state.discount)) * Number(window.ipoLogin.ipo_type.lotSize * this.state.ipoQty)}</span></div>

                        <div className="ipo-qty-wrap">
	                        <span className="ipo-qty-plus" onClick={() => {
                            // if( window.ipoLogin.ipo_type.symbol === 'ADANIENTPP' && window.ipoLogin.ipo_type.lotSize * this.state.ipoQty >= 152){
                            //   return;
                            // }
                            // if( window.ipoLogin.ipo_type.symbol === 'ADANIENTPP' && window.ipoLogin.ipo_type.lotSize * this.state.ipoQty >= 60){
                            //   this.setState({discount : 0});
                            // }

                            // if(((window.ipoLogin.ipo_type.cutOffPrice - Number(this.state.discount)) * Number(window.ipoLogin.ipo_type.lotSize * (this.state.ipoQty + 1))) >= 200000){
                            //   window.ipoLogin.ipo_type.category.map((cat) => {
                            //     if("NIB" === cat.code && this.state.category === "IND"){
                            //       this.setState({category : cat.code, discount: cat.discount })
                            //     }
                            //   });
                            // }

                            if(((window.ipoLogin.ipo_type.cutOffPrice - Number(this.state.discount)) * Number(window.ipoLogin.ipo_type.lotSize * (this.state.ipoQty + 1))) < 500000){
                              this.setState({ipoQty : Number(this.state.ipoQty+1)})
                            }
                          }}>+</span>
                          <label id="ipo-qty" className="form-control">{this.state.ipoQty}</label>
                          <span className="ipo-qty-minus" onClick={() => {
                            // if(window.ipoLogin.ipo_type.lotSize * this.state.ipoQty <= 64){
                            //   window.ipoLogin.ipo_type.category.map((cat) => {
                            //     if(this.state.category === cat.code){
                            //       this.setState({discount: cat.discount })
                            //     }
                            //   });
                            // }

                            // if(((window.ipoLogin.ipo_type.cutOffPrice - Number(this.state.discount)) * Number(window.ipoLogin.ipo_type.lotSize * (this.state.ipoQty - 1))) <= 200000){
                            //   window.ipoLogin.ipo_type.category.map((cat) => {
                            //     if("IND" === cat.code && this.state.category === "NIB"){
                            //       this.setState({category : cat.code, discount: cat.discount })
                            //     }
                            //   });
                            // }
                            this.setState({ipoQty : (this.state.ipoQty > 1) ? Number(this.state.ipoQty-1) : 1})
                          }}>-</span>
                        </div>
                      </div>
                    </div>
                    <div className="md-form mb-3">
                      <input type="text" id="ipo-bid-upi" placeholder="Enter you UPI" className="form-control rounded-pill" required onChange={(e) => this.setState({bid_UPI : e.target.value})} />
                    </div>
                    <div className="md-form mb-3 form-check">
                      <input className="form-check-input" type="checkbox" id="ipo-terms-check" required onChange={(e) => this.setState({ipo_terms : e.target.checked === true ? 'true' : 'false' })}/>
                      <label className="form-check-label" htmlFor="ipo-terms-check">
                        Yes, I agree and request PWAPL Tear to apply for {window.ipoLogin.ipo_type.name} IPO for me, agaist my UPI id/Trading Code. I have read and understood terms & conditions.
                      </label>
                    </div>
                    <button className={' btn btn-primary ipo-add-bid-apply '+(this.state.clientCode && this.state.category && this.state.bid_UPI.includes("@") && this.state.ipo_terms==='true' ? '' : 'disabled')} disalbed={this.state.clientCode && this.state.category && this.state.bid_UPI.includes("@") && this.state.ipo_terms==='true' ? false : true} onClick={() => this.addIPOBids()}>Apply Now</button>
                  </div>
              </div>
            </div>
          </div>
        }
        {this.state.message &&
        <div className="modal d-block" id="ipo-bid-form">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header text-center">
              <h6 className="modal-title w-100 font-weight-bold">Message</h6>
                <button type="button" className="close" onClick={() => {
                    this.setState({apply_now : false, ipo_apply : false, error_msg : '', message: ''}) 
                    window.location.href = 'https://'+window.location.host+'/'
                  }}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body mx-3">
                <div className="md-form mb-3">
                  <h6>{this.state.message}</h6>
                </div>
              </div>
              </div>
            </div>
          </div>
        }
    </div>
    <IpoFooter />
    </Fragment>
  );
    }
}
